import { type FC } from "react";
import { useFlags } from "../../../../server/optimizely";
import { usePopover } from "../../../../utils/hooks/use-popover";
import { ColourPickerV1 } from "./colour-picker-v1";
import { ColourPickerV2 } from "./colour-picker-v2";

export const ColourPicker: FC<{
  popover: ReturnType<typeof usePopover<HTMLElement>>;
  onInput?: (color: string, skipAddingToHistoryStack?: boolean) => void;
  onChange: (color: string, skipAddingToHistoryStack?: boolean) => void;
  colour: string;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}> = ({ popover, onInput, onChange, colour, inputRef }) => {
  const {
    flags: { use_new_colour_picker },
  } = useFlags("use_new_colour_picker");

  if (use_new_colour_picker)
    return (
      <ColourPickerV2 popover={popover} onChange={onChange} colour={colour} inputRef={inputRef} />
    );

  return (
    <ColourPickerV1
      popover={popover}
      onInput={onInput}
      onChange={onChange}
      colour={colour}
      inputRef={inputRef}
    />
  );
};
